export const STEPS_ID = {
	LOGIN: 0,
	INFO: 1,
	DOCUMENTS: 2,
	PAYMENT: 3,
	FINISH: 4,
	RESET: 5,
	COMPANY: 6,
	PAYER: 7,
	PAYER_JUNIORS: 8,
	INFO_JUNIORS: 9,
	ADMISSION: 10,
};

export const STEPS = {
	LOGIN: 'login',
	LOGIN_JUNIORS: 'loginJuniors',
	LOGIN_ID: 'loginId',
	INFO: 'info',
	INFO_JUNIORS: 'infoJuniors',
	DOCUMENTS: 'documents',
	PAYMENT: 'payment',
	FINISH: 'finish',
	COMPANY: 'company',
	RESET: 'reset',
	PAYER: 'payer',
	PAYER_JUNIORS: 'payerJuniors',
	ADMISSION: 'admission',
};

export const STEPS_COMPONENT = {
	login: 'AuthStep',
	loginId: 'AuthStepWithId',
	info: 'FirstStep',
	infoJuniors: 'FirstStepJuniors',
	documents: 'SecondStep',
	payment: 'ThirdStep',
	finish: 'SuccessStep',
	company: 'CompanyStep',
	payer: 'PayerStep',
	payerJuniors: 'PayerStepJuniors',
	admission: 'AdmissionStep',
};

export const FINISH_STEP = 'finish';

export const LOGIN_STEP = {
	id: STEPS_ID.LOGIN,
	name: STEPS.LOGIN,
	title: 'Логин / регистрация',
	completed: true,
};

export const PAYER_STEP = {
	id: STEPS_ID.PAYER,
	name: STEPS.PAYER,
	title: 'Тип плательщика',
	completed: true,
};

export const PAYER_JUNIORS_STEP = {
	id: STEPS_ID.PAYER_JUNIORS,
	name: STEPS.PAYER_JUNIORS,
	title: 'Тип плательщика',
	completed: true,
};

export const INFO_STEP = {
	id: STEPS_ID.INFO,
	name: STEPS.INFO,
	title: 'Основная информация',
	completed: true,
};

export const INFO_JUNIORS_STEP = {
	id: STEPS_ID.INFO_JUNIORS,
	name: STEPS.INFO_JUNIORS,
	title: 'Основная информация',
	completed: true,
};

export const DOCUMENTS_STEP = {
	id: STEPS_ID.DOCUMENTS,
	name: STEPS.DOCUMENTS,
	title: 'Документы',
	completed: false,
};

export const COMPANY_STEP = {
	id: STEPS_ID.COMPANY,
	name: STEPS.COMPANY,
	title: 'Сведения о компании',
	completed: false,
};

export const ADMISSION_STEP = {
	id: STEPS_ID.ADMISSION,
	name: STEPS.ADMISSION,
	title: 'Адмиссия',
	completed: false,
};

export const PAYMENT_STEP = (isPhysicalPayer) => ({
	id: STEPS_ID.PAYMENT,
	name: STEPS.PAYMENT,
	title: isPhysicalPayer ? 'Способ оплаты' : 'Оплатить по счету',
	completed: false,
});

export const STEPS_LIST = [
	LOGIN_STEP,
	PAYER_STEP,
	INFO_STEP,
	DOCUMENTS_STEP,
];
